__turbopack_context__.v({
  "consentCheckbox": "checkBoxForForm-module-scss-module__4CifLq__consentCheckbox",
  "privacyPolicyLink": "checkBoxForForm-module-scss-module__4CifLq__privacyPolicyLink",
});
